import { 
  GET_WEBHOOK_DATA_REQUEST, 
  GET_WEBHOOK_DATA_SUCCESS, 
  GET_WEBHOOK_DATA_FAILURE 
} from '../actions/billingActions';

const initialState = {
  webhookData: null,
  loading: false,
  error: null
};

export default function billingReducer(state = initialState, action) {
  switch (action.type) {
    case GET_WEBHOOK_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    
    case GET_WEBHOOK_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        webhookData: action.payload,
        error: null
      };
    
    case GET_WEBHOOK_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    
    default:
      return state;
  }
}
